export enum ApplicationName {
  Bareka = 'bareka',
  Rekensprint = 'rekensprint',
  ATR = 'atr',
}
